import { CHALLENGE_12_TEAM_BADGES_MILESTONE } from "../../challengeConstants";
const points = [
  {
    index: 0,
    top: "28.5",
    left: "14.5",
    subPoint: [
      { top: "28.5", left: "14.5" },
      { top: "28.5", left: "14.5" },
      { top: "28.5", left: "14.5" },
    ],
    type: "main",
    label: "amway",
    totalStep: 0,
  },
  {
    index: 1,
    top: "35.5",
    left: "25.5",
    subPoint: [
      { top: "36.5", left: "23.5" },
      { top: "35.5", left: "21.5" },
      { top: "32.5", left: "19.5" },
    ],
    type: "pin",
    totalStep: 500,
  },
  {
    index: 2,
    top: "24",
    left: "37.5",
    subPoint: [
      { top: "27", left: "34.5" },
      { top: "28.5", left: "32.5" },
      { top: "30.5", left: "30.5" },
    ],
    type: "pin",
    totalStep: 25000,
  },
  {
    index: 3,
    top: "17",
    left: "46",
    subPoint: [
      { top: "19", left: "44" },
      { top: "20", left: "42" },
      { top: "22", left: "40" },
    ],
    type: "pin",
    totalStep: 50000,
  },
  {
    index: 4,
    top: "10.5",
    left: "54",
    subPoint: [
      { top: "12", left: "52" },
      { top: "14", left: "50" },
      { top: "16", left: "48" },
    ],
    type: "pin",
    totalStep: 75000,
  },

  {
    index: 5,
    top: "28",
    left: "59",
    subPoint: [
      { top: "28", left: "59" },
      { top: "28", left: "59" },
      { top: "28", left: "59" },
    ],
    type: "main",
    label: CHALLENGE_12_TEAM_BADGES_MILESTONE.badge1,
    totalStep: 100000,
    badgeY: -84,
    badgeX: -112,
    height: 170,
    cloudTop: -130,
    cloudLeft: 50,
  },

  {
    index: 6,
    top: "39",
    left: "45.3",
    subPoint: [
      { top: "35", left: "47" },
      { top: "29.5", left: "47.4" },
      { top: "26.2", left: "49.5" },
    ],
    type: "pin",
    totalStep: 100500,
  },

  {
    index: 7,
    top: "56",
    left: "37",
    subPoint: [
      { top: "56", left: "37" },
      { top: "56", left: "37" },
      { top: "56", left: "37" },
    ],
    type: "main",
    label: CHALLENGE_12_TEAM_BADGES_MILESTONE.badge2,
    totalStep: 200000,
    badgeY: -125,
    badgeX: -46,
    height: 180,
    cloudTop: -155,
    cloudLeft: 0,
  },

  {
    index: 8,
    top: "47",
    left: "52",
    subPoint: [
      { top: "50.5", left: "49.5" },
      { top: "51.5", left: "46.5" },
      { top: "50.5", left: "43.5" },
    ],
    type: "pin",
    totalStep: 200500,
  },

  {
    index: 9,
    top: "52",
    left: "58",
    subPoint: [
      { top: "52", left: "58" },
      { top: "52", left: "58" },
      { top: "52", left: "58" },
    ],
    type: "main",
    label: CHALLENGE_12_TEAM_BADGES_MILESTONE.badge3,
    totalStep: 300000,
    badgeY: -70,
    badgeX: -105,
    height: 140,
    cloudTop: -145,
    cloudLeft: -20,
  },

  {
    index: 10,
    top: "56",
    left: "58.2",
    subPoint: [
      { top: "53", left: "59.7" },
      { top: "50.5", left: "61" },
      { top: "47.5", left: "61.5" },
    ],
    type: "pin",
    totalStep: 300500,
  },

  {
    index: 11,
    top: "78",
    left: "55",
    subPoint: [
      { top: "78", left: "55" },
      { top: "78", left: "55" },
      { top: "78", left: "55" },
    ],
    type: "main",
    label: CHALLENGE_12_TEAM_BADGES_MILESTONE.badge4,
    totalStep: 400000,
    badgeY: -140,
    badgeX: -90,
    height: 200,
    cloudTop: -190,
    cloudLeft: 50,
  },

  {
    index: 12,
    top: "78.5",
    left: "44.5",
    subPoint: [
      { top: "74", left: "45" },
      { top: "74", left: "48" },
      { top: "72", left: "51" },
    ],
    type: "pin",
    totalStep: 400500,
  },
  {
    index: 13,
    top: "84.5",
    left: "58.5",
    subPoint: [
      { top: "87", left: "55.5" },
      { top: "86", left: "52" },
      { top: "84", left: "49" },
    ],
    type: "pin",
    totalStep: 420000,
  },
  {
    index: 14,
    top: "65.5",
    left: "67.5",
    subPoint: [
      { top: "71.5", left: "68.5" },
      { top: "75.5", left: "65.5" },
      { top: "78.5", left: "62.5" },
    ],
    type: "pin",
    totalStep: 440000,
  },
  {
    index: 15,
    top: "48",
    left: "66",
    subPoint: [
      { top: "52", left: "64.5" },
      { top: "56", left: "63.5" },
      { top: "60", left: "65" },
    ],
    type: "pin",
    totalStep: 460000,
  },
  {
    index: 16,
    top: "36",
    left: "72",
    subPoint: [
      { top: "40", left: "70" },
      { top: "43", left: "68" },
      { top: "46", left: "67" },
    ],
    type: "pin",
    totalStep: 480000,
  },
  {
    index: 17,
    top: "37",
    left: "79",
    subPoint: [
      { top: "37", left: "79" },
      { top: "37", left: "79" },
      { top: "37", left: "79" },
    ],
    type: "main",
    label: CHALLENGE_12_TEAM_BADGES_MILESTONE.badge5,
    totalStep: 500000,
    badgeY: -110,
    badgeX: 70,
    height: 200,
    cloudTop: -160,
    cloudLeft: 0,
  },

  {
    index: 18,
    top: "45",
    left: "86.5",
    subPoint: [
      { top: "41", left: "86.5" },
      { top: "39", left: "86" },
      { top: "35", left: "85" },
    ],
    type: "pin",
    totalStep: 500500,
  },

  {
    index: 19,
    top: "55.5",
    left: "86.5",
    subPoint: [
      { top: "53", left: "86" },
      { top: "50.5", left: "86" },
      { top: "48", left: "86" },
    ],
    type: "pin",
    totalStep: 535000,
  },

  {
    index: 20,
    top: "65",
    left: "82",
    subPoint: [
      { top: "65", left: "84.5" },
      { top: "64", left: "86.8" },
      { top: "59", left: "87.5" },
    ],
    type: "pin",
    totalStep: 565000,
  },
  {
    index: 21,
    top: "60",
    left: "84",
    subPoint: [
      { top: "50", left: "84" },
      { top: "60", left: "84" },
      { top: "60", left: "84" },
    ],
    type: "main",
    label: CHALLENGE_12_TEAM_BADGES_MILESTONE.badge6,
    totalStep: 600000,
    badgeY: -45,
    badgeX: -195,
    height: 166,
    cloudTop: -105,
    cloudLeft: -115,
  },
];

export default points;


